module.exports = __webpack_public_path__ + "img/brand_3.369be77a.png";